import React from 'react';
import { LANGUAGE_STORAGE_KEY, languageOptions } from './languages';

export default function LanguageSelect({ compact = false, className = '' }) {
  const [language, setLanguage] = React.useState(() => localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en');

  React.useEffect(() => {
    const onLanguage = (event) => setLanguage(event.detail?.language || localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en');
    window.addEventListener('rozops-language-change', onLanguage);
    return () => window.removeEventListener('rozops-language-change', onLanguage);
  }, []);

  const changeLanguage = (value) => {
    setLanguage(value);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, value);
    window.dispatchEvent(new CustomEvent('rozops-language-change', { detail: { language: value } }));
  };

  return (
    <div className={`notranslate ${className}`} translate="no">
      <label className="sr-only" htmlFor="rozops-language-select">Language</label>
      <select
        id="rozops-language-select"
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
        className={`${compact ? 'max-w-[132px] text-xs px-2.5 py-2' : 'max-w-[160px] text-xs sm:text-sm px-3 py-2'} rounded-xl border border-gray-100 bg-white font-semibold text-rozops-text-muted focus:outline-none focus:ring-2 focus:ring-rozops-blue/20 focus:border-rozops-blue`}
        data-testid="language-select"
      >
        {languageOptions.map(([code, label]) => <option key={code} value={code}>{label}</option>)}
      </select>
    </div>
  );
}
